const validateFilter = (filter) => {
  const error = {};
  if (!filter.width) {
    error.widthErr = 'Width is required.';
  }
  if (!filter.height) {
    error.heightErr = 'Height is required';
  }
  if (!filter.thickness) {
    error.thicknessErr = 'Thickness is required';
  }
  if (!filter.location) {
    error.locationErr = 'Location is required';
  } else if (filter.location && filter.location.length > 20) {
    error.locationErr = '20 Character max';
  }
  if (!filter.ventLocation) {
    error.ventLocationErr = 'Vent location is required';
  }
  if (!filter.merv) {
    error.mervErr = 'Quality is required';
  }
  if (!filter.brand) {
    error.brandErr = 'Brand is required';
  }
  if (!filter.serviceAddressId) {
    error.addressErr = 'Address is required.';
  }
  if (!filter.catalogId) {
    error.sizeErr = 'Size is required';
  }
  if (filter.sbsFilter) {
    if (!filter.sbsWidth) {
      error.sbsWidthErr = 'Width is required.';
    }
    if (!filter.sbsHeight) {
      error.sbsHeightErr = 'Height is required';
    }
    if (!filter.sbsThickness) {
      error.sbsThicknessErr = 'Thickness is required';
    }
    if (!filter.sbsCatalogId) {
      error.sbsSizeErr = 'Size is required';
    }
  }
  return error;
};

export default validateFilter;
